module.exports = __webpack_public_path__ + "static/media/logoorange.6614c159.png";